import Vue from 'vue'
import filters from 'common/filters.js'

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
export default filters
